import type { IsoDate, YearMonth } from '../data/types';

const euro = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const compactEuro = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  notation: 'compact',
  maximumFractionDigits: 1,
});

const monthFormatter = new Intl.DateTimeFormat('it-IT', { month: 'short', year: '2-digit' });
const dateFormatter = new Intl.DateTimeFormat('it-IT', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});

export function formatCents(value: number): string {
  return euro.format(value / 100);
}

export function formatCompactCents(value: number): string {
  return compactEuro.format(value / 100);
}

export function formatPercent(value: number | null): string {
  return value === null
    ? 'Non significativo'
    : new Intl.NumberFormat('it-IT', {
        style: 'percent',
        signDisplay: 'exceptZero',
        maximumFractionDigits: 1,
      }).format(value);
}

export function formatMonth(value: YearMonth | string): string {
  const [year = 0, month = 1] = value.split('-').map(Number);
  return monthFormatter.format(new Date(Date.UTC(year, month - 1, 1)));
}

export function formatDate(value: IsoDate | string): string {
  const [year = 0, month = 1, day = 1] = value.split('-').map(Number);
  return dateFormatter.format(new Date(Date.UTC(year, month - 1, day)));
}

export function signedClass(value: number): 'positive' | 'negative' | 'neutral' {
  return value > 0 ? 'positive' : value < 0 ? 'negative' : 'neutral';
}
